export const MAP_ART_CREATOR_PATH = "/";
export const WORLD_EDIT_GUIDE_PATH = "/guides/placing-map-schematics-with-worldedit";
export const LITEMATICA_GUIDE_PATH = "/guides/map-schematics-with-litematica";
